module.exports = __webpack_public_path__ + "static/media/question-mark.b4d9fcba.svg";